import { render, staticRenderFns } from "./ChartsBetNumber.vue?vue&type=template&id=f86029f4&"
import script from "./ChartsBetNumber.vue?vue&type=script&lang=js&"
export * from "./ChartsBetNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports